/* eslint no-alert: 0 */

import Components from "../components";

class ShortcutForm extends Components.Base {
  bind() {
    this.projectSelect.on("change", () => this.onProjectChanged());
  }

  unbind() {
    this.button.off("click");
  }

  initialize() {
    this.apiKey = this.$el.find("#channel_api_key");
    this.projectSelect = this.$el.find("#channel_external_project_id");
    this.resolveSelect = this.$el.find("#channel_resolve_transition");
    this.reopenSelect = this.$el.find("#channel_reopen_transition");
    this.projectId = this.$el.data("channel-shortcut-project-id-value");
    this.channelId = this.$el.data("channel-shortcut-channel-id-value");

    this.$el.find("select").attr("disabled", true);

    this.$el.find("#fetch_project_info").remove();
    this.button = $("<button>", {
      text: "Fetch project info",
      class: "btn btn-sm btn-soft-primary mt-2",
      id: "fetch_project_info",
      type: "button",
    });
    this.button.on("click", (e) => {
      e.preventDefault();
      this.fetchProjectInfo();
    });
    this.$el.find(".mb-3:has(#channel_api_key)").append(this.button);

    if (this.apiKey.val().length > 0) {
      this.fetchProjectInfo();
    }
  }

  fetchProjectInfo() {
    $.ajax(this.buildUrl("/projects"), {
      type: "get",
      dataType: "json",
      success: (...args) => this.populateProjects(...args),
      error: (...args) => this.reportError(...args),
    });
  }

  buildUrl(path) {
    const params = new URLSearchParams({ token: this.apiKey.val() });
    if (this.channelId) {
      params.set("channel_id", this.channelId);
    }
    return `/projects/${this.projectId}/channels/shortcut${path}?${params}`;
  }

  populateProjects(items) {
    const selected = Number.parseInt(this.projectSelect.attr("value"), 10);
    this.projectSelect.empty();

    items.forEach((item) => {
      this.projectSelect.append(
        $("<option>", {
          value: item.id,
          text: item.name,
          selected: item.id === selected,
        }),
      );
    });

    this.projectSelect.removeAttr("disabled");
    this.projectSelect.trigger("change");
  }

  fetchWorkflowInfo(shortcutProjectId) {
    return $.ajax(
      this.buildUrl(`/workflow_states`) +
        `&shortcut_project_id=${shortcutProjectId}`,
      {
        type: "get",
        dataType: "json",
        success: (...args) => this.populateWorkflowStates(...args),
        error: (...args) => this.reportError(...args),
      },
    );
  }

  populateWorkflowStates(items) {
    const result = [];

    [this.resolveSelect, this.reopenSelect].forEach((sel) => {
      const selected = Number.parseInt(sel.attr("value"), 10);
      sel.empty();
      items.forEach((item) => {
        sel.append(
          $("<option>", {
            value: item.id,
            text: item.name,
            selected: item.id === selected,
          }),
        );
      });
      sel.removeAttr("disabled");
      result.push(sel.trigger("change"));
    });
  }

  onProjectChanged() {
    const selectedProject = this.projectSelect.find("option:selected");
    this.$el.find("#channel_project_name").val(selectedProject.text());
    return this.fetchWorkflowInfo(selectedProject.val());
  }

  reportError(xhr, status, error) {
    if (error.match(/forbidden/i)) {
      alert("Shortcut access denied: Invalid API Key");
    }
  }
}

Components.collection.register({
  selector: "form[data-kind=shortcut]",
  klass: ShortcutForm,
});
